import React from "react";

export default function ErrorPage() {
  return (
    <>
      <h2>ERROR 404 PAGE FOUND!</h2>
    </>
  );
}
